<template>
    <div>
        <v-row class="mx-1">
            <v-spacer></v-spacer>
            <!-- <span><PreviewFileFilter :resetFilter="resetFilter" @filter="filterItems"/></span>
            <v-icon v-if="factDataFilter && factDataFilter.where && factDataFilter.where.length" @click="clearFilter" class="pointer info--text"
                >mdi-filter-remove</v-icon
            >-->
            <PreviewDataFilter
                :showCheckboxes="true"
                @filter="filterItems"
                :customDisable="customDisable"
                :value="factDataUnformattedFilter"
                @saveFilter="saveFilterData"
            />
        </v-row>
        <div class="fact-data">
            <v-data-table
                id="previw-file"
                height="600"
                :headers="headers"
                :items="factData"
                :server-items-length="factDataLength"
                :options.sync="factDataPagination"
                :loading="factDataLoading"
                :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
                ref="table"
            >
                <template v-slot:item.meter_rid="{ item }">
                    <table-cell-tooltip :header="headers[0]" :item="item">
                        <span>{{ item.meter_rid }}</span>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.meter_number="{ item }">
                    <table-cell-tooltip :header="headers[1]" :item="item">
                        <span>{{ item.meter_number }}</span>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.date_consumption_begin="{ item }">
                    <table-cell-tooltip :header="headers[2]" :item="item" filter="formatDate">
                        <span>{{ item.date_consumption_begin | formatDate }}</span>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.date_consumption_end="{ item }">
                    <table-cell-tooltip :header="headers[3]" :item="item" filter="formatDate">
                        <span>{{ item.date_consumption_end | formatDate }}</span>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.temperature_in="{ item }">
                    <table-cell-tooltip :header="headers[4]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.temperature_in | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.temperature_out="{ item }">
                    <table-cell-tooltip :header="headers[5]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.temperature_out | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.water_weight_on_gvs="{ item }">
                    <table-cell-tooltip :header="headers[6]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.water_weight_on_gvs | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.water_weight_out="{ item }">
                    <table-cell-tooltip :header="headers[7]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.water_weight_out | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.heat_energy_all="{ item }">
                    <table-cell-tooltip :header="headers[8]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.heat_energy_all | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.temp_cold_water="{ item }">
                    <table-cell-tooltip :header="headers[9]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.temp_cold_water | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
                <template v-slot:item.work_time="{ item }">
                    <table-cell-tooltip :header="headers[10]" :item="item" filter="formatDecimal">
                        <div class="number-cell">{{ item.work_time | formatDecimal }}</div>
                    </table-cell-tooltip>
                </template>
            </v-data-table>
            <table-arrows :table="$refs.table"></table-arrows>
        </div>
    </div>
</template>

<script>
import PreviewDataFilter from './PreviewDataFilter';
import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';
import { isFilterEmpty } from '@/utils';
import { mapActions, mapState } from 'vuex';

export default {
    props: ['id'],
    components: {
        PreviewDataFilter,
        TableCellTooltip,
        TableArrows
    },
    data: () => ({
        resetFilter: false
    }),
    watch: {
        groupedDataPagination: function() {
            this.getFactData(this.id);
        }
    },
    async mounted() {
        this.$watch(
            '$vuetify.breakpoint.xsOnly',
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.factDataPagination.itemsPerPage = 1;
                }
                if (oldVal) {
                    this.factDataPagination.itemsPerPage = 10;
                }
                this.factDataPagination.page = 1;
            },
            { immediate: true }
        );
        this.getFactData(this.id);
    },
    computed: {
        ...mapState('uploads', ['fileDetail', 'factData', 'factDataLoading', 'factDataLength', 'factDataFilter']),
        factDataPagination: {
            get() {
                return this.$store.state.uploads.factDataPagination;
            },
            set(val) {
                this.$store.commit('uploads/setFactDataPagination', val);
            }
        },
        factDataUnformattedFilter: {
            get() {
                return this.$store.state.uploads.factDataUnformattedFilter;
            },
            set(val) {
                this.$store.commit('uploads/setFactDataUnformattedFilter', val);
            }
        },
        customDisable() {
            return isFilterEmpty(this.factDataUnformattedFilter);
        },
        headers() {
            return [
                {
                    text: this.$t('ID номер ПУТЭ'),
                    value: 'meter_rid',
                    width: '3%'
                },
                {
                    text: this.$t('Заводской номер ПУТЭ'),
                    value: 'meter_number',
                    width: '1%'
                },
                {
                    text: this.$t('Дата начала'),
                    value: 'date_consumption_begin',
                    width: '2%'
                },
                {
                    text: this.$t('Дата окончания'),
                    value: 'date_consumption_end',
                    width: '1%'
                },
                {
                    text: this.$t('Температура ПВ (С)'),
                    value: 'temperature_in',
                    width: '1%'
                },
                {
                    text: this.$t('Температура ОВ (С)'),
                    value: 'temperature_out',
                    width: '1%'
                },
                {
                    text: this.$t('Масса воды на ГВС'),
                    value: 'water_weight_on_gvs',
                    width: '1%'
                },
                {
                    text: this.$t('Масса воды в ОВ'),
                    value: 'water_weight_out',
                    width: '1%'
                },
                {
                    text: this.$t('Теплоэнергия общая'),
                    value: 'heat_energy_all',
                    width: '1%'
                },
                {
                    text: this.$t('Температура Хол. воды'),
                    value: 'temp_cold_water',
                    width: '2%'
                },
                {
                    text: this.$t('Рабочее время (ч)'),
                    value: 'work_time',
                    width: '2%'
                }
            ];
        }
    },
    methods: {
        ...mapActions('uploads', ['getFactData']),
        async filterItems(val) {
            this.$store.commit('uploads/setFactDataFilter', val);
            await this.getFactData(this.id);
        },
        clearFilter() {
            this.resetFilter = true;
            this.$store.commit('uploads/setFactDataFilter', null);
            setTimeout(() => {
                this.resetFilter = false;
            }, 500);
        },
        saveFilterData(val) {
            this.factDataUnformattedFilter = val;
        }
    }
};
</script>

<style lang="scss">
.fact-data {
    .v-data-table th {
        white-space: initial !important;
        text-align: start !important;
    }
}
</style>
